import apiFetch from '../apiFetch'

export default function (token, id) {
  return apiFetch({ endPoint: `Metadata/${id}`, method: 'DELETE', body: null, token: token })
}
